{
  "salon-details-header": {
    "buttons": {
      "link-copied": "ĐÃ SAO CHÉP",
      "share": "CHIA SẺ",
      "visit-virtually": "THAM QUAN SALON ẢO"
    }
  }
}
